import CryptoJS from 'crypto-js';

const defaultKey = 'w5izqpo1kkdm3aukqlpegfm0salldb3m';
const gatKey = `${process.env.VUE_APP_GAT_AES_KEY}` || defaultKey;

function encrypt(word, keyCode) {
  if (!word) {
    return;
  }
  if (!keyCode || keyCode === "") {
    throw new Error("AES key must not be empty")
  }
  // 16位秘钥（128bit），支持128位、192位、256位key
  let key = CryptoJS.enc.Utf8.parse(keyCode);
  // 16位矢量码
  let encrypted = '';
  if (typeof word == 'string') {
    let srcs = CryptoJS.enc.Utf8.parse(word);
    encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: '',
      mode: CryptoJS.mode.ECB,
      // PKCS5Padding或PKCS7Padding
      padding: CryptoJS.pad.Pkcs7,
    });
  } else if (typeof word == 'object') {
    // 对象格式的转成json字符串
    let data = JSON.stringify(word);
    let srcs = CryptoJS.enc.Utf8.parse(data);
    encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: '',
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
  }
  return encodeURIComponent(CryptoJS.enc.Base64.stringify(encrypted.ciphertext));
}

function decrypt(word, keyStr) { // 解密
  let key = CryptoJS.enc.Utf8.parse(keyStr);
  let decrypt = CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}

export default {
  encrypt,decrypt,defaultKey,gatKey
}
